'use client'

import { useState, type ReactNode } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { FaChevronDown } from 'react-icons/fa6'
import classNames from 'classnames'

interface DopProps {
    title: string
    children: ReactNode
    defaultOpen?: boolean
}

export const DopCollapse = ({
    title,
    children,
    defaultOpen = false,
}: DopProps) => {
    const [isOpen, setIsOpen] = useState(defaultOpen)

    const handleToggle = () => setIsOpen((prev) => !prev)

    return (
        <section className="border-b border-gray-200 py-2">
            {/* Заголовок */}
            <button
                onClick={handleToggle}
                className="flex w-full items-center justify-between text-left"
                aria-expanded={isOpen}
                aria-controls={`${title}-content`}
            >
                <div className="text-gray-800 text-sm md:text-base font-bold">
                    {title}
                </div>
                <FaChevronDown
                    className={classNames(
                        'transition-transform duration-300 text-gray-500',
                        isOpen && 'rotate-180',
                    )}
                    size={16}
                />
            </button>

            {/* Контент с анимацией */}
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        key="content"
                        id={`${title}-content`}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.25, ease: 'easeInOut' }}
                        className="overflow-hidden"
                    >
                        <div className="mt-3 p-3">{children}</div>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    )
}
